import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import LoadingSpinner from "../../LoadingSpinner";
import Input from "../../input/Input";
import SearchDropdown from "../../input/SearchDropdown";
import {
  getBulkDropdownData,
  getDropdownData,
  getOtherRefSearchDropdown,
  getTextByValueAndKey,
} from "../../../api/keyvalue";
import Dropdown from "../../input/Dropdown";
import Button from "../../input/Button";
import Grid from "../../Grid";
import {
  ActiveCellStyle,
  ResizableScrollingTextRenderer,
  StatusCellStyle,
} from "../../renderer/StyleRenderer";
import ButtonRenderer from "../../renderer/ButtonRenderer";
import { FORMS, MODULES } from "../../../const";
import { getBehalfOf, getUsernameById } from "../../../api/systemUserApi";
import { alertValidation } from "../../validations/AlertCreation";
import { shiftUserAssignValidation } from "../../validations/ShiftAssignmentCreation";
import { StatusById } from "../../../api/statusApi";
import DeleteButtonRenderer from "../../renderer/DeleteButtonRenderer";

const FORM = FORMS.CALL_CENTER_SHIFT_ASSIGNMENT.SHIFT_USER.form;
const ShiftAssignmentUsers = forwardRef(
  (
    { errors, dropdown, isLoading, currentValues, editMode, userGroupLoad },
    ref,
  ) => {
    const [currentErrors, setCurrentErrors] = useState({});
    const [currentAssignUser, setCurrentAssignUser] = useState({});

    const [assignUsers, setAssignUsers] = useState([]);
    const [deletedList, setDeletedList] = useState([]);

    //counter
    const [assignUserCount, setAssignUserCount] = useState(2);
    const [userGroupCount, setUserGroupCount] = useState(2);

    // flags
    const [searchFieldReset, setSearchFieldReset] = useState(false);
    const [fieldReset, setFieldReset] = useState(false);
    const [isAddLoading, setIsAddLoading] = useState(false);
    const [buttonClicked, setButtonClicked] = useState(false);
    const [currentAssignUserEdit, setCurrentAssignUserEdit] = useState(false);

    //dropdown
    const [activeOptions, setActiveOptions] = useState([]);
    const [statusOptions, setStatusOptions] = useState([]);

    const [shiftAssignUserData, setShiftAssignUserData] = useState({
      sduCode: "",
      sduReference: "",
      sduCompany: "",
      sduShiftHeader: "",
      sduUser: "",
      sduDate: "",
      sduDescription: "",
      sduStatus: 2,
      sduActive: 1,
    });
    useEffect(() => {
      (async () => {
        // new
        const { active: activeData, status: statusData } =
          await getBulkDropdownData([{ key: "active" }, { key: "status" }]);

        setActiveOptions(activeData);
        setStatusOptions(statusData);
      })();
    }, []);

    useEffect(() => {
      if (buttonClicked) {
        setShiftAssignUserData({
          sduCode: "",
          sduReference: "",
          sduCompany: "",
          sduShiftHeader: "",
          sduUser: "",
          sduDate: "",
          sduDescription: "",
          sduStatus: 2,
          sduActive: 1,
        });

        setButtonClicked(false);
        setSearchFieldReset(true);
        setFieldReset(true);
        setCurrentAssignUser({});
      }
    }, [buttonClicked]);
    const onAddClick = async () => {
      setIsAddLoading(true);

      let userAssignErrors = shiftUserAssignValidation({
        ...shiftAssignUserData,
      });
      if (Object.keys(userAssignErrors).length === 0) {
        const sduStatusValue = await getTextByValueAndKey(
          "status",
          shiftAssignUserData.sduStatus,
        );
        const sduActiveValue = await getTextByValueAndKey(
          "active",
          shiftAssignUserData.sduActive,
        );
        const username = await getUsernameById(shiftAssignUserData.sduUser);

        if (!shiftAssignUserData.sduId || shiftAssignUserData.sduId === null) {
          if (!shiftAssignUserData.id || shiftAssignUserData.id === null) {
            setAssignUsers((prevState) => [
              ...prevState,
              {
                ...shiftAssignUserData,
                id: assignUserCount,
                sduStatusValue,
                sduActiveValue,
                username,
              },
            ]);
            setAssignUserCount((prevState) => ++prevState);
          } else {
            setAssignUsers((prevState) =>
              prevState.filter((item) => item.id !== shiftAssignUserData.id),
            );
            setAssignUsers((prevState) => [
              ...prevState,
              {
                ...shiftAssignUserData,
                sduStatusValue,
                sduActiveValue,
                username,
              },
            ]);
          }
        } else {
          setAssignUsers((prevState) =>
            prevState.filter(
              (item) => item.sduId !== shiftAssignUserData.sduId,
            ),
          );
          setAssignUsers((prevState) => [
            ...prevState,
            {
              ...shiftAssignUserData,
              sduStatusValue,
              sduActiveValue,
              username,
              modified: true,
            },
          ]);
        }
        setButtonClicked(true);
        setIsAddLoading(false);
      }
      setCurrentErrors(userAssignErrors);
      setIsAddLoading(false);
    };

    const getUpdateState = () => {
      const updateState = {
        modified: [],
        created: [],
        unmodified: [],
        deleted: deletedList,
      };
      assignUsers.forEach((sdu) => {
        if (sdu.sduId && sdu.sduId !== null) {
          if (sdu.modified) {
            updateState.modified.push(sdu);
          } else {
            updateState.unmodified.push(sdu);
          }
        } else {
          updateState.created.push(sdu);
        }
      });
      return updateState;
    };
    useImperativeHandle(ref, () => ({
      getData: () => {
        if (editMode) {
          return getUpdateState();
        } else {
          return assignUsers;
        }
      },

      resetForm: () => {
        setButtonClicked(true);
        setAssignUsers([]);
      },
      validateForm: () => {
        if (editMode) {
          const userData = getUpdateState();
          const modifiedUserDataData = userData.modified;
          const newUserDataData = userData.created;
          const unModifiedData = userData.unmodified;
          return (
            modifiedUserDataData.length +
              newUserDataData.length +
              unModifiedData.length <=
            0
          );
        } else {
          return assignUsers.length <= 0;
        }
      },
    }));

    useEffect(() => {
      (async () => {
        if (editMode) {
          let currentActions = [];
          let id = 2;
          for (let currentValue of currentValues) {
            const sduStatusValue = await getTextByValueAndKey(
              "status",
              currentValue.sduStatus,
            );
            const sduActiveValue = await getTextByValueAndKey(
              "active",
              currentValue.sduActive,
            );
            const username = await getUsernameById(currentValue.sduUser);
            currentActions.push({
              ...currentValue,
              sduStatusValue,
              sduActiveValue,
              username,
              id,
            });
            ++id;
          }
          setAssignUserCount(id);
          setAssignUsers(currentActions);
        }
      })();
    }, [editMode, currentValues]);

    useEffect(() => {
      (async () => {
        if (!editMode) {
          if (userGroupLoad.length > 0) {
            let currentActions = [];
            let id =
              assignUsers.length > 0
                ? assignUsers[assignUsers.length - 1].id
                : 2;
            let uid = 2;
            for (let currentValue of userGroupLoad) {
              const sduStatusValue = await getTextByValueAndKey(
                "status",
                currentValue.sguStatus,
              );
              const sduActiveValue = await getTextByValueAndKey(
                "active",
                currentValue.sguActive,
              );
              const username = await getUsernameById(currentValue.sguUserName);
              currentActions.push({
                ...currentValue,
                sduStatusValue,
                sduActiveValue,
                username,
                sduUser: currentValue.sguUserName,
                sduActive: currentValue.sguActive,
                sduStatus: currentValue.sguStatus,
                sduDescription: currentValue.sguDescription,
                id,
                uid,
              });
              ++id;
              ++uid;
            }
            setAssignUserCount(id);
            setAssignUsers([]);
            setAssignUsers((prevState) => [...prevState, ...currentActions]);
          } else {
            const usersWithUid = assignUsers.filter((item) => item.uid);
            const uidsToRemove = new Set(usersWithUid.map((user) => user.uid));
            const updatedAssignUsers = assignUsers.filter(
              (user) => !uidsToRemove.has(user.uid),
            );
            setAssignUsers(updatedAssignUsers);
          }
        }
      })();
    }, [userGroupLoad]);

    useEffect(() => {
      if (Object.keys(currentAssignUser).length > 0) {
        setShiftAssignUserData({
          ...currentAssignUser,
        });
      }
    }, [editMode, currentAssignUser]);

    return (
      <>
        {isLoading ? (
          <LoadingSpinner />
        ) : (
          <form
            className="ui form"
            style={{ overflowY: "auto", height: "75vh" }}
          >
            <div className="ui segment">
              <h4 className="ui dividing header">User Assignment</h4>
              <div className="two fields">
                <Input
                  label="Shift User code"
                  error={currentErrors.sduCode}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sdu_code"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sduCode: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  name="shiftUserCode"
                  value={shiftAssignUserData.sduCode}
                  onChange={(e) => {
                    setShiftAssignUserData((prevState) => ({
                      ...prevState,
                      sduCode: e.target.value,
                    }));
                  }}
                  disabled={true}
                />
              </div>
              <div className="two fields">
                <SearchDropdown
                  key={1}
                  required={true}
                  editMode={editMode}
                  multiGrid={true}
                  multiGridCurrentValue={shiftAssignUserData.username}
                  reset={searchFieldReset}
                  setReset={setSearchFieldReset}
                  clearable={true}
                  api={getOtherRefSearchDropdown}
                  apiDependency={{
                    type: "shift_users",
                    value: "",
                  }}
                  fieldInfo={{
                    tableName: "authentication.user",
                    primaryKey: "user_seq",
                    fieldName: "username",
                    id: shiftAssignUserData.sduUser,
                  }}
                  onResultSelect={(data) => {
                    setShiftAssignUserData((prevState) => ({
                      ...prevState,
                      sduUser: data,
                    }));
                  }}
                  onClear={() => {
                    setShiftAssignUserData((prevState) => ({
                      ...prevState,
                      sduUser: null,
                    }));
                  }}
                  error={currentErrors.sduUser}
                  resetError={() => {
                    setCurrentErrors((prevState) => {
                      const { sduUser: _, ...rest } = prevState;
                      return rest;
                    });
                  }}
                  label="User"
                  field="req_behalf_of"
                />

                <Input
                  label="Description"
                  error={currentErrors.sduDescription}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sdu_description"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sduDescription: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Description"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  value={shiftAssignUserData.sduDescription}
                  onChange={(e) => {
                    setShiftAssignUserData((prevState) => ({
                      ...prevState,
                      sduDescription: e.target.value,
                    }));
                  }}
                />
              </div>
              <div className="two fields">
                <Dropdown
                  required={true}
                  label="Status"
                  error={currentErrors.sduStatus}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sdu_status"
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sduStatus: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Status"
                  options={statusOptions}
                  value={shiftAssignUserData.sduStatus}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftAssignUserData((prevState) => ({
                      ...prevState,
                      sduStatus: data.value,
                    }));
                  }}
                />
                {/* <Dropdown
                  required={true}
                  label="Active"
                  error={currentErrors.sduActive}
                  module={MODULES.Transaction}
                  form={FORM}
                  field="sdu_active"
                  // authenticated={true}
                  needDeletePermission={true}
                  editMode={editMode}
                  resetError={() =>
                    setCurrentErrors((prevState) => {
                      const { sduActive: _, ...rest } = prevState;
                      return rest;
                    })
                  }
                  placeholder="Active"
                  options={activeOptions}
                  value={shiftAssignUserData.sduActive}
                  style={{ height: "20px" }}
                  onChange={(e, data) => {
                    setShiftAssignUserData((prevState) => ({
                      ...prevState,
                      sduActive: data.value,
                    }));
                  }}
                /> */}
                
              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "flex-end",
                  gap: "5px",
                }}
              >
                <Button
                  template="reset"
                  onClick={(e) => {
                    setButtonClicked(true);
                  }}
                />
                <Button
                  template="addOrSave"
                  authenticated={true}
                  module={MODULES.Transaction}
                  form={`${FORM}`}
                  create={Object.keys(currentAssignUser).length === 0}
                  onClick={onAddClick}
                  isLoading={isAddLoading}
                />
              </div>
              <Grid
                heading="Users"
                config={[
                  { headerName: "User", field: "username" },
                  {
                    headerName: "Description",
                    field: "sduDescription",
                    cellRenderer: ResizableScrollingTextRenderer,
                  },
                  {
                    headerName: "Active",
                    field: "sduActiveValue",
                    cellRenderer: ActiveCellStyle,
                  },
                  {
                    headerName: "Status",
                    field: "sduStatusValue",
                    cellRenderer: StatusCellStyle,
                  },
                  {
                    field: "Edit",
                    filter: true,
                    cellRenderer: ButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        setCurrentAssignUser(params.data);
                      },
                      label: "Edit",
                      editMode: editMode,
                      authenticated: true,
                      form: `${FORM}`,
                      module: MODULES.Transaction,
                    }),
                  },
                  {
                    field: "Delete",
                    filter: true,
                    cellRenderer: DeleteButtonRenderer,
                    cellRendererParams: (params) => ({
                      clickHandler: () => {
                        if (params.data?.sduId && params.data.sduId !== null) {
                          setDeletedList((prev) => [
                            ...prev,
                            params.data.sduId,
                          ]);
                        }
                        setAssignUsers((prev) =>
                          prev.filter((user) => user.id !== params.data.id),
                        );
                      },
                      message:
                        "Are you sure you want to delete this user assignment?",
                      label: "Delete",
                      className: "ui red button",
                    }),
                  },
                ]}
                content={assignUsers}
              />
            </div>
          </form>
        )}
      </>
    );
  },
);
export default ShiftAssignmentUsers;
